import { render, staticRenderFns } from "./_animated-gradient-bg.vue?vue&type=template&id=030c124f&scoped=true"
import script from "./_animated-gradient-bg.vue?vue&type=script&lang=js"
export * from "./_animated-gradient-bg.vue?vue&type=script&lang=js"
import style0 from "./_animated-gradient-bg.vue?vue&type=style&index=0&id=030c124f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c124f",
  null
  
)

export default component.exports